import { createColumn, defaultColumns, inputTextField, booleanComponent } from '../_defaults/columns'

export const columns = [
  createColumn({
    label: 'Description',
    isTitle: true,
    field: 'description',
    component: inputTextField({ req: true })
  }),
  createColumn({
    label: 'Constant Contact List ID',
    field: 'ccListId',
    // section: 'Constant Contact',
    visible: false,
    component: null
  }),
  createColumn({
    label: 'Constant Contact Sync Enabled',
    field: 'ccSyncEnabled',
    type: 'boolean',
    // section: 'Constant Contact',
    component: booleanComponent
  })
].concat(defaultColumns)
